import React from "react"
import QuickLinks from "../QuickLinks"
import {Container, Wrapper} from "./component"
import connect from "./connect"
import {QuickLinkProps} from "../QuickLink"

export type QuickLinksContainerProps = {
    quickLinks: QuickLinkProps[] | undefined
    containerStyles?: React.ComponentPropsWithoutRef<typeof Container>["sx"]
}

export const QuickLinksContainer = ({containerStyles, quickLinks}: QuickLinksContainerProps) => {
    if (!quickLinks || quickLinks.length === 0) return null
    return (
        <Wrapper data-testid="header-adaptive-links" className="header-adaptive-links">
            <Container sx={containerStyles}>
                <div className="header-adaptive-quicklinks" data-testid="header-adaptive-quicklinks">
                    <QuickLinks quickLinks={quickLinks as any} />
                </div>
            </Container>
        </Wrapper>
    )
}

export default connect(QuickLinksContainer)
